import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=864e8d74&scoped=true&"
var script = {}
import style0 from "./Navbar.vue?vue&type=style&index=0&id=864e8d74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864e8d74",
  null
  
)

export default component.exports